import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import styled from 'styled-components';
import Text from '../../../common/base/Text';
import { Div } from '../../../common/helpers/StyledUtils';
import ViewRoute from '../../../common/ViewRoute';
import { TeamPermission } from '../../../contexts/TeamPermissionContext';
import { StyledViewContent, StyledViewLayout } from '../../../layouts/ViewLayout';
import { DashboardContext } from '../../DashboardScene/DashboardContext';
import { StyledSettingsNavHeader } from '../../DashboardScene/Nav/SettingsNav';
import AccountProfile from '../../DashboardScene/Settings/Account/AccountProfile';
import OrganizationBilling from '../../DashboardScene/Settings/Organization/OrganizationBilling';
import OrganizationMembers from '../../DashboardScene/Settings/Organization/OrganizationMembers';
import OrganizationPlans from '../../DashboardScene/Settings/Organization/OrganizationPlans';
import OrganizationApiKeys from '../../DashboardScene/Settings/Organization/OrganizationApiKeys';
import OrganizationSettings from '../../DashboardScene/Settings/Organization/OrganizationSettings';
import TeamAccessControl from '../../DashboardScene/Settings/Team/TeamAccessControl';
import OperatorEventDestinationView from './OperatorEventDestinationView';
import SettingsNav from './SettingsNav';
import TeamApiKey from './TeamApiKey';
import TeamSettings from './TeamSettings';
import TeamUserPortal from './TeamUserPortal';
import DestinationsSettings from './DestinationsSettings';
import MonitoringSettings from './MonitoringSettings';
import PublishingSettings from './PublishingSettings';
const StyledSettingsView = styled.div`
  display: grid;
  grid-template-columns: 224px 1fr;
  position: relative;

  > div:first-child {
    height: fit-content;
    position: sticky;
  }
`;
const Settings: React.FC = () => {
  const $ = _c(16);
  const {
    is_degraded_banner_active
  } = useContext(DashboardContext);
  let sections;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    sections = {
      project: [{
        key: "settings",
        path: "/settings/project/general",
        label: "Project Settings",
        icon: "settings",
        Component: TeamSettings
      }, {
        key: "destinations",
        path: "/settings/project/destinations",
        label: "Destinations",
        icon: "destination",
        Component: DestinationsSettings
      }, {
        key: "monitoring",
        path: "/settings/project/monitoring",
        label: "Monitoring",
        icon: "search",
        Component: MonitoringSettings
      }, {
        key: "user-portal",
        path: "/settings/project/user-portal",
        label: "User Portal",
        icon: "user",
        Component: TeamUserPortal
      }, {
        key: "publishing",
        path: "/settings/project/publishing",
        label: "Publishing",
        icon: "publish",
        Component: PublishingSettings
      }, {
        key: "secrets",
        path: "/settings/project/secrets",
        label: "API Keys",
        icon: "key",
        Component: TeamApiKey
      }, {
        key: "access",
        path: "/settings/project/access",
        label: "Project Access Control",
        icon: "group",
        Component: TeamAccessControl
      }],
      organization: [{
        key: "general",
        path: "/settings/organization/general",
        label: "Organization",
        icon: "settings",
        Component: OrganizationSettings
      }, {
        key: "members",
        path: "/settings/organization/members",
        label: "Organization Members",
        icon: "team",
        Component: OrganizationMembers
      }, {
        key: "api_keys",
        path: "/settings/organization/api-keys",
        label: "Organization API Keys",
        icon: "key",
        Component: OrganizationApiKeys
      }, {
        key: "billing",
        path: "/settings/organization/billing",
        label: "Organization Billing",
        icon: "billing",
        Component: OrganizationBilling
      }, {
        key: "plans",
        path: "/settings/organization/plans",
        label: "Hookdeck Plans",
        icon: "billing",
        Component: OrganizationPlans
      }, {
        key: "outpost_plans",
        path: "/settings/organization/outpost/plans",
        label: "Hookdeck Outpost Plans",
        icon: "billing",
        Component: OrganizationPlans
      }]
    };
    const is_outpost_plans_path = location.pathname.includes("/settings/organization/outpost/plans");
    const sections_list = [...sections.project, ...sections.organization];
    t0 = is_outpost_plans_path ? sections.organization.find(_temp) : sections_list.find(_temp2);
    $[0] = sections;
    $[1] = t0;
  } else {
    sections = $[0];
    t0 = $[1];
  }
  const current_section = t0;
  const match_operator_event_destination = useRouteMatch("/settings/project/monitoring/:destination_id");
  if (match_operator_event_destination) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <StyledViewLayout><StyledViewContent><TeamPermission role="member"><OperatorEventDestinationView /></TeamPermission></StyledViewContent></StyledViewLayout>;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "center",
      justify: "space-between"
    };
    t2 = {
      x: 6,
      y: 4
    };
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Text semi={true}>{current_section?.label || "Profile"}</Text>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== is_degraded_banner_active) {
    t4 = <StyledSettingsNavHeader flex={t1} p={t2} is_degraded_banner_active={is_degraded_banner_active}>{t3}</StyledSettingsNavHeader>;
    $[6] = is_degraded_banner_active;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SettingsNav />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      direction: "column"
    };
    t7 = {
      t: 6,
      b: 8
    };
    $[9] = t6;
    $[10] = t7;
  } else {
    t6 = $[9];
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <ViewRoute title="Profile" path="/settings/account/profile" render={_temp3} />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Route path="/settings/project" render={() => <TeamPermission role="member"><Div><Switch>{sections.project.map(_temp4)}<Redirect to="/settings/project/general" /></Switch></Div></TeamPermission>} />;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <StyledSettingsView>{t5}<Div flex={t6} p={t7}><Div><Switch>{t8}{t9}<Route path="/settings/organization" render={() => <TeamPermission role="member"><Switch>{sections.organization.map(_temp5)}<Redirect to="/settings/organization/general" /></Switch></TeamPermission>} /><Redirect to="/settings/project/general" /></Switch></Div></Div></StyledSettingsView>;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t4) {
    t11 = <StyledViewLayout><StyledViewContent>{t4}{t10}</StyledViewContent></StyledViewLayout>;
    $[14] = t4;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
};
export default Settings;
function _temp(section) {
  return section?.key === "plans";
}
function _temp2(section_0) {
  return location.pathname.includes(section_0?.path || "");
}
function _temp3() {
  return <Div><AccountProfile /></Div>;
}
function _temp4(section_1) {
  return <ViewRoute title={section_1.label} path={section_1.path} key={section_1.key}><section_1.Component /></ViewRoute>;
}
function _temp5(section_2) {
  return <ViewRoute title={section_2.label} path={section_2.path} key={section_2.key}><section_2.Component /></ViewRoute>;
}